import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_PIPELINES_ACTION_TYPE } from '../actions';

const initialState = {};

const kanbanReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case LOAN_PIPELINES_ACTION_TYPE.FETCH_KANBAN_VIEW_DATA:
        draft[payload.pipelineId] = {
          isLoading: true,
          error: null,
          columns: [],
          totalLoanCount: 0,
        };
        break;

      case LOAN_PIPELINES_ACTION_TYPE.FETCH_KANBAN_VIEW_DATA_SUCCESS:
        draft[payload.pipelineId] = {
          isLoading: false,
          error: null,
          columns: payload.data.columns,
          totalLoanCount: payload.data.totalLoanCount,
        };
        break;

      case LOAN_PIPELINES_ACTION_TYPE.FETCH_KANBAN_VIEW_DATA_FAILURE:
        draft[payload.pipelineId] = {
          ...draft[payload.pipelineId],
          isLoading: false,
          error: payload.error,
        };
        break;

      case LOAN_PIPELINES_ACTION_TYPE.MOVE_KANBAN_CARD: {
        const pipeline = draft[payload.pipelineId];
        const sourceColumn = pipeline?.columns?.find(
          column => column.columnId === payload.fromColumnId,
        );
        const targetColumn = pipeline?.columns?.find(
          column => column.columnId === payload.toColumnId,
        );

        if (!sourceColumn || !targetColumn) {
          break;
        }

        const cardIndex = sourceColumn.cards.findIndex(card => card.entryId === payload.entryId);

        if (cardIndex === -1) {
          break;
        }

        const [movedCard] = sourceColumn.cards.splice(cardIndex, 1);

        targetColumn.cards.unshift(movedCard);
        sourceColumn.loanCount = sourceColumn.cards.length;
        targetColumn.loanCount = targetColumn.cards.length;
        break;
      }

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default kanbanReducer;
